'use client'

import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'
import { useModalState } from '@/utils/hooks/useModalState'
import { useUrlProvider } from '@/utils/url/hooks/useUrlProvider'
import { useRouter } from 'next/navigation'
import React from 'react'
import { Button } from '@/components/atoms/Button'

const FlyerBuilderHeader = () => {
	const modalState = useModalState()
	const router = useRouter()
	const provideUrl = useUrlProvider()
	const sitecoreStore = useSitecoreState((state) => state)

	const closeLabel = sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-CLOSE', 'Close')
	const buildYourFlyerLabel = sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-MSC-BUILD_YOUR_FLYER', 'Build your flyer')
	const buildYourFlyerDescriptionLabel = sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-MSC-CHOOSE_YOUR_FLYER', 'Choose the subject of your flyer')

	const handleClose = () => {
		modalState.openInfoModal({
			variant: 'confirm-abort',
			children: sitecoreStore.getLabel(TranslationBundles.BUILD_YOUR_FLYER, 'MSC-BUILD_YOUR_FLYER-CLOSE-MESSAGE', 'Are you sure you want to close the flyer builder?'),
			confirmBehavior: () => {
				router.push(provideUrl('home'))
				modalState.close()
			},
		})
	}

	return (
		<>
			<div className="flex items-center px-6 pt-6">
				<div className="ml-auto">
					<Button variant="filledTertiary" onClick={handleClose}>
						{closeLabel}
					</Button>
				</div>
			</div>
			<div className="flex items-center justify-center px-6">
				<div className="flex flex-col py-6 gap-6">
					<h2 className="uppercase text-msc-blue text-3xl font-bold text-center">{buildYourFlyerLabel}</h2>
					<p className="text-msc-blue text-xl font-bold text-center">{buildYourFlyerDescriptionLabel}</p>
				</div>
			</div>
		</>
	)
}

export { FlyerBuilderHeader }
